import React from "react";
import PropTypes from "prop-types";
import SectionsTitle from "../SectionTitle/SectionTitle";

const propTypes = {
  content: PropTypes.shape({}).isRequired,
  is2Column: PropTypes.bool,
};

const GrayCardsWrapper = ({ content, is2Column }) => {
  return (
    <>
      <div className="h-technology">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <SectionsTitle
                subtitle={content.cards.subTitle}
                title={content.cards.title}
              />
            </div>
          </div>
        </div>
        <section className="technology-area">
          <div className="container">
            <div
              className={[
                "technology-items-grid",
                is2Column ? "columns-2" : "",
              ].join(" ")}
            >
              {content.cards.items.map((item, index) => {
                return (
                  <div className="technology-items" key={index}>
                    <h3 className="technology-items-title">
                      <span className="title d-none text-center m-0">
                        {item.title}
                      </span>
                    </h3>
                    <p className="technology-items-description">
                      {item.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const defaultProps = {
  is2Column: false,
};
GrayCardsWrapper.propTypes = propTypes;
GrayCardsWrapper.defaultProps = defaultProps;

export default GrayCardsWrapper;
